import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  AnalyticsService,
  CustomerService,
  EnvironmentService,
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import {
  AlertsService,
  ModalService,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import {
  getFavoriteContentWithHighestRank,
  MobileProduct,
  Option,
  OptionStatus,
  OptionType,
  PdaResponseModel,
  PlcCodes,
} from '@dch/products-business-logic';
import { combineLatest } from 'rxjs';
import {
  ApplicationState,
  getEbuOrderingLogs,
  getOptionsCategoriesConfig,
  getSelectedProductDetails,
  getSettingsCategoriesConfig,
} from '../../../store/reducers';
import { OptionDetailsBaseComponent } from '../option-details-base/option-details-base.component';

@Component({
  selector: 'mprd-ebu-option-details',
  templateUrl: './ebu-option-details.component.html',
  styleUrls: ['./ebu-option-details.component.css'],
})
export class EbuOptionDetailsComponent
  extends OptionDetailsBaseComponent
  implements OnInit
{
  @Input() selectedProduct: MobileProduct;
  @Input() isConfigurableOption: boolean;
  @Input() flexPackDiscountText: string;
  @Input() option: Option;

  hideCeaseButton: boolean;
  startDate: Date;
  isPayDateInFuture: boolean;
  payDateInFutureText: string;
  isEbuOrderingEnabled: boolean;

  debugMode: boolean;
  debugLogs: string;

  OptionType = OptionType;
  OptionStatus = OptionStatus;
  PlcCodes = PlcCodes;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<ApplicationState>,
    languageService: LanguageService,
    alertService: AlertsService,
    customerService: CustomerService,
    private ref: ChangeDetectorRef,
    private cdRef: ChangeDetectorRef,
    translationService: TranslationService,
    protected inceptionService: InceptionService,
    location: Location,
    modalService: ModalService,
    analyticsService: AnalyticsService,
    pxModalMessageService: PxModalMessageService,
    environmentService: EnvironmentService,
  ) {
    super(
      translationService,
      languageService,
      alertService,
      customerService,
      location,
      modalService,
      pxModalMessageService,
      analyticsService,
      environmentService,
    );
  }

  ngOnInit(): void {
    this.addSubscription(
      combineLatest([
        this.activatedRoute.params,
        this.store.select(getSelectedProductDetails),
        this.store.select(getOptionsCategoriesConfig),
        this.store.select(getSettingsCategoriesConfig),
        this.store.select(getEbuOrderingLogs),
      ]).subscribe((res: [Params, PdaResponseModel, any, any, string]) => {
        const params = res[0];
        const selectedProduct = res[1];
        const optionsConfig = res[2];
        const settingsConfig = res[3];
        this.debugLogs = res[4];

        const optionMpcUuid = this.getOptionMpcUuid(params);

        if (
          optionMpcUuid &&
          selectedProduct &&
          optionsConfig &&
          settingsConfig
        ) {
          this.setOptionName();
          this.setOptionDescriptionName();
          this.setDiscountTextVisible();
        }
      }),
    );
    this.inceptionService.init();
    this.startDate = new Date(this.option?.startDate);
    const currentDate = new Date();
    this.isPayDateInFuture = this.startDate > currentDate;
    this.payDateInFutureText = this.translationService
      .getTranslatedValueFor('option.details.isPayDateInFuture')
      .replace('{0}', this.startDate.toLocaleDateString());
    this.isEbuOrderingEnabled =
      this.translationService.getTranslatedValueFor('ebu.ordering.enabled') ===
      'true';

    this.debugMode =
      sessionStorage.getItem('debugwebview')?.toLowerCase() == 'true';
  }

  private getOptionMpcUuid(params: Params) {
    return params['mpcUuid'] ? params['mpcUuid'] : params['deepLinkMpcUuid'];
  }

  setDiscountTextVisible() {
    if (this.selectedProduct) {
      const favContent: Option = getFavoriteContentWithHighestRank(
        this.selectedProduct,
      );
      this.flexPackDiscountText =
        this.option && this.option.favContentMessage !== undefined
          ? this.option.favContentMessage[
              this.languageService.getSelectedLanguage() || 'en'
            ]
          : undefined;
    } else {
      this.flexPackDiscountText = undefined;
    }
  }

  isOptionIncluded(includedOption: boolean) {
    this.hideCeaseButton = !includedOption;
    this.cdRef.detectChanges();
  }

  public buildRedirectURL() {
    const url =
      this.option?.redirectLink?.url[
        this.languageService.getSelectedLanguage()
      ];
    return url;
  }
}
